import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";


const state = {

};

const getters = {

};

const actions = {
	// 发送重置邮件
	resetPassword({commit}, data) {
		let api = API_MAP.USER_RESET_PWD;
		let method = 'post';
		let payload = data;
		let successCb = () => {
			window.location.reload();
		};
		let errorCb = () => {};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	}
};

const mutations = {

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
